






































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {Notify} from '@/utils/Notify';

import {ILoraForwarderStatsStore} from '@/store/lora/ILoraForwarderStats.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import JsonEditor from '@/components/Utils/JsonEditor.vue';
import LoraForwarderConfigFileEditor from '@/components/Lora/Forwarder/LoraForwarderConfigFileEditor.vue';
import LoraForwarderControl from '@/components/Lora/Forwarder/LoraForwarderControl.vue';
import LoraForwarderConfiguration from '@/components/Lora/Forwarder/LoraForwarderConfiguration.vue';
import LoraForwarderLog from '@/components/Lora/Forwarder/LoraForwarderLog.vue';
import ValueDisplayer from '@/components/Utils/ValueDisplayer.vue';

@Component({
  components: {
    ValueDisplayer,
    LoraForwarderLog,
    JsonEditor, LoraForwarderConfigFileEditor, LoraForwarderControl, LoraForwarderConfiguration,
  },
})
export default class LoraForwarderStats extends Mixins<BaseComponent>(BaseComponent) {
  @Prop()
  private forwarderStore!: ILoraForwarderStatsStore;

  private async mounted() {
    await this.refreshStats();
    this.setLoaded();
  }

  private async refreshStats() {
    try {
      await this.forwarderStore.fetchStats();
    } catch (error) {
      Notify.Error(this.logger, `Could not get stats`, error);
    }
  }

  private async resetStats() {
    try {
      await this.forwarderStore.resetStats();
    } catch (error) {
      Notify.Error(this.logger, `Could not reset stats`, error);
    }
  }
}

